import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { darkModeClass } from '../../utils/cn';
import styles from './Footer.module.css';

const Footer = () => {
  const { isDarkMode } = useTheme();
  const { data, t, formatNumber } = useLanguage();
  const personalData = data.personal;
  const currentYear = formatNumber(new Date().getFullYear());

  return (
    <footer className={`${styles.footer} ${darkModeClass(styles, isDarkMode)}`}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.footerSection}>
            <div className={styles.logo}>
              <span className={styles.logoText}>{personalData.name.split(' ')[0]}</span>
              <span className={styles.logoDot}>.</span>
            </div>
            <p className={styles.footerBio}>{t('footer.bio')}</p>
          </div>
          
          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>{t('footer.quickLinks')}</h3>
            <ul className={styles.footerLinks}>
              <li><a href="#projects">{t('nav.projects')}</a></li>
              <li><a href="#skills">{t('nav.skills')}</a></li>
              <li><a href="#experience">{t('nav.experience')}</a></li>
              <li><a href="#contact">{t('nav.contact')}</a></li>
            </ul>
          </div>
          
          <div className={styles.footerSection}>
            <h3 className={styles.footerTitle}>{t('footer.connect')}</h3>
            <div className={styles.footerSocial}>
              {personalData.socialLinks.map((link) => (
                <a 
                  key={link.url}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerSocialLink}
                  aria-label={link.name}
                >
                  <i className={`fab ${link.icon}`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        
        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            &copy; {currentYear} {personalData.name}. {t('footer.rights')}
          </p>

        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);